"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../schema");
const value = schema_1.Schema.number()
    .expiration(15552000)
    .unit("mg/L")
    .precision(2)
    .min(0)
    .max(1000)
    .interpretation({ vocab: "htx", code: "crp" })
    .tag({ vocab: "snomed", code: "55235003" })
    .tag({ vocab: "loinc", code: "1988-5" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "396550006" })
    .tag({ vocab: "htx", code: "lab_inflamm" });
